module.exports = __webpack_public_path__ + "static/media/stress@3x.645c9552.png";